<template>
<v-container>
  <v-form>
  <v-flex xs6 offset-xs3>
    <v-layout row>
      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
    </v-layout>
    <div class="text-xs-center">
      <!-- <label class="headline">St�dutbildning AB</label> -->
      <img src="../assets/images/logga_medium.png">
    </div>
    <v-layout row>
      <v-text-field v-model="userinfo.email" name="login" label="E-post" type="text" v-on:keyup="checkreturn"></v-text-field>
    </v-layout>
    <v-layout row>
      <v-text-field v-model="userinfo.password" id="password" name="password" label="L�senord" type="password" v-on:keyup="checkreturn"></v-text-field>
    </v-layout>
    <v-layout row>
      <v-flex xs2>
        <v-btn color="secondary" flat @click="glomtlosen">Gl�mt l�senord</v-btn>
      </v-flex>
      <v-flex xs4 offset-xs6>
        <v-btn color="primary" block @click="login">Logga in</v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  </v-form>
</v-container>
</template>

<script>
import axios from 'axios'
import {HTTP} from '@/backend/client'
// import { EventBus } from '@/store/event-bus.js'

export default {
  name: 'Login',
  data () {
    return {
      userinfo: {
        email: '',
        password: ''
      },
      loading: false
      // error: ''
    }
  },
  methods: {
    checkreturn (e) {
      if (e.keyCode === 13) {
        this.login()
      }
    },
    login () {
      this.loading = true
      var params = 'username=' + this.userinfo.email + '&password=' + encodeURIComponent(this.userinfo.password)
      delete HTTP.defaults.headers.common['Authorization']
      axios({ method: 'post', url: process.env.API_URL + 'token', data: params, headers: { 'accept': 'application/json', 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.loginSuccessful(response)
        })
        .catch(ex => {
          this.loginFailed(ex)
        })
    },
    loginSuccessful (req) {
      if (!req.data) {
        this.loginFailed()
        return
      }
      if (HTTP.defaults.headers.common['Authorization'] === undefined) {
        HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + req.data
      }
      HTTP.post('/account/getkund', 'epost=' + this.userinfo.email)
        .then(response => {
          this.$store.dispatch('appcurrent/saveAuthorization', {username: this.userinfo.email, isauthorized: true, bearertoken: req.data})
          this.$router.push({ path: '/' })
          this.loading = false
        })
        .catch(e => {
          // this.error = e
          this.$store.dispatch('appcurrent/showError', e.message)
          this.loading = false
        })
    },
    loginFailed (e) {
      this.loading = false
      // this.error = 'Kontrollera anv�ndarnamn'
      this.$store.dispatch('appcurrent/showError', 'Kontrollera anv�ndarnamn och/eller l�senord')
      this.$store.dispatch('appcurrent/deleteAuthorization')
    },
    glomtlosen () {
      this.$router.push({ path: '/glomtlosen' })
    }
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue